import { useAdminHeaderContext } from '@src/providers/AdminHeaderContext';
import { lazy, Suspense, useCallback } from 'react';
const AdminHeader = lazy(() => import('@src/components/TalosAdminHeader'));

export function TalosAdminHeaderWrapper({ onReload }: { onReload?: () => void }) {
  const { showAdminHeader, isAdminHeaderDismissed, setIsAdminHeaderDismissed } = useAdminHeaderContext();
  /* Admin Header must be accessible to Talos users even if essential providers cannot load.  */
  /* UserContextProvider is guaranteed to resolve by this point. */

  // passing this in to make testing of AdminHeader easier
  const onReloadCallback = useCallback(() => {
    onReload ? onReload() : window.location.reload?.();
  }, [onReload]);

  return (
    showAdminHeader && (
      <Suspense fallback={<div>Loading admin header</div>}>
        <AdminHeader
          isDismissed={isAdminHeaderDismissed}
          setIsDismissed={setIsAdminHeaderDismissed}
          onReload={onReloadCallback}
        />
      </Suspense>
    )
  );
}
